module.exports = __webpack_public_path__ + "img/flow_customer-service_hover.3a663210.svg";